<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Export"
      placement="top"
    >
      <el-button
        size="mini"
        :loading="exportButtonLoader"
        icon="el-icon-download"
        @click="exportStockTransformation"
      />
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['stockTransformation'],
    data() {
      return {
        exportButtonLoader: false,
      };
    },

    methods: {
       async exportStockTransformation() {
        try {
          this.exportButtonLoader = true;
          const excel = await axios({
            url: 'api/stock-transformations/' + this.stockTransformation.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'stock_transformation_items.xlsx');
        } catch (e) {
        }
        this.exportButtonLoader = false;

      },
    }
  };
</script>
